// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e5d803c8","455":"00e0f3aa","977":"233fd205"}[chunkId] + ".chunk.js";
};